var React = require('react');

function Letterboxd (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25,50A25,25,0,1,1,50,25,25,25,0,0,1,25,50ZM16.5,10.3v28H35.41564V31.31007H23.77239V10.3Z","fill":"#10141a"}));
}

Letterboxd.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = Letterboxd;

Letterboxd.default = Letterboxd;
